<div class="timeline">

  @for (activity of activities; track activity) {
    <div class="timeline-item">
      <div class="timeline-date">
        <span class="timeline-date-date">{{ activity.actionDateTime | date : dateShort}}</span>
        <span class="timeline-date-time">{{ activity.actionDateTime | date : 'HH:mm'}}</span>
      </div>
      <div class="timeline-bullet">
        @if (activity.weightLevel >= 99) {
          <mat-icon matListItemAvatar class="highest">warning</mat-icon>
        }
        @if (activity.weightLevel >= 80 && activity.weightLevel < 99) {
          <mat-icon matListItemAvatar class="high">
            notification_important
          </mat-icon>
        }
        @if (activity.weightLevel < 80) {
          <mat-icon matListItemAvatar>notifications</mat-icon>
        }
      </div>
      <div class="timeline-content">
        <span class="timeline-title">{{ activity.title }}</span>
        @if (showOriginDateTime) {
          <p class="activity-origin-date">Récéptionné le {{activity.data.activity.actionDateTime | date : 'dd/MM/yyyy à HH:mm'}}</p>
        }
        @if (activity.data?.commentaire && !isActivityDesistement(activity)) {
          <p class="activity-message">{{ activity.data.commentaire }}</p>
        }
        @if (activity.title !== activity.message && !isMessageOldDesistement(activity)) {
          <p class="activity-message">{{ activity.message }}</p>
        }
        <div class="timeline-actions">
          @if (activity.user) {
            <a class="timeline-author" href="mailto:{{ activity.user.email }}">
              <mat-icon>perm_identity</mat-icon>
              {{ activity.user.prenom }} {{ activity.user.nom }}
            </a>
          }
          @if (isAdmin && !activity['showCommentBox'] && activity.comments?.length === 0) {
            <a
              (click)="showCommentBox(activity)"
              href="javascript:void(0)"
              >
              <mat-icon>chat_bubble_outline</mat-icon>
              Commenter
            </a>
          }
        </div>
        <app-log-comments-list [activity]="activity.data.activity" [hideCommentBox]="true"></app-log-comments-list>
        <app-log-comments-list [activity]="activity" [showCommentBox]="activity['showCommentBox']"></app-log-comments-list>
      </div>
    </div>
  }

</div>
